<template lang="pug">
  v-container
    v-row
      v-col(
        cols="12"
      )
        v-row(v-if="authPermissions.has('sales:create')")
          v-col(
            lg="2"
            cols="12"
          )
            import-sale-inventories
          v-col(
            lg="2"
            cols="12"
          )
            export-sale-inventories
          v-col(lg="2" cols="12")
            import-from-pos(
              color="green"
              block
              dark
            ) 
              template(v-slot:default) Import POS
        v-expansion-panels(v-if="authPermissions.has('sales:view')")
          v-expansion-panel
              v-expansion-panel-header(
                color="primary"
                dark
                class="white--text"
              )
                template(v-slot:actions)
                  v-icon.icon.white--text $expand
                  span Transactions
              v-expansion-panel-content
                index-sale-inventories(
                  @edit="editSaleInv"
                  ref="indexSaleInventoriesRef"
                )
      v-col(cols="12")
        create-sale-inventories(v-if="authPermissions.has('sales:create')" @upload-success="() => $refs.indexSaleInventoriesRef.getData()")
    v-dialog(
      max-width="600px"
      v-model="editRecInventories"
      eager
      class="pa-0"
    )
      v-card
        edit-sale-inventories(
          ref="editSaleInventories"
          @close-dialog="editRecInventories = false" 
          @update-success="() => $refs.indexSaleInventoriesRef.getData()"
        )
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'VSaleInventories',
  components: {
    createSaleInventories: () => import('./../components/sale-inventories/v2/Create'),
    indexSaleInventories: () => import('./../components/sale-inventories/v2/Index'),
    editSaleInventories: () => import('./../components/sale-inventories/v2/Edit'),
    importSaleInventories: () => import('./../components/sale-inventories/Import'),
    importFromPos: () => import('@/views/dashboard/components/sale-inventories/ImportFromPos'),
    exportSaleInventories: () => import('./../components/sale-inventories/Export'),
  },
  data() {
    return {
      editRecInventories: false,
    }
  },
  computed: {
    ...mapState({
      authPermissions: state => state.auth.userPermissions,
    }),
  },
  methods: {
    editSaleInv(data) {
      this.$refs?.editSaleInventories?.init(data.id)
      this.editRecInventories = true
    },
  },
}
</script>
